(() => {
  if (window.PuzzlePupSeptemberGift) return;
  const eligibleIds = new Set([45943769956492, 45943804461196, 45943912857740]);
  const giftId = 55545731907724;
  // Half-price cart add-ons are only sold beside a full-price item, one of each.
  const addonHandles = new Set(['25-cookie-add-on-50-off', '40-cookie-add-on-50-off', 'allergy-chews-add-on-50-off', 'hip-joint-chews-add-on-50-off', 'skin-coat-chews-add-on-50-off', 'snuffle-mat-add-on-50-off']);
  const route = path => (window.Shopify?.routes?.root || '/') + path;
  let activeSync = null, rerun = false, checkoutBusy = false;
  const allowedForms = new WeakSet();
  async function request(path, payload) {
    const response = await fetch(route(path), {
      credentials: 'same-origin', method: payload ? 'POST' : 'GET',
      headers: { Accept: 'application/json', ...(payload ? { 'Content-Type': 'application/json' } : {}) },
      ...(payload ? { body: JSON.stringify(payload) } : {})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(window.PuzzlePupCroLabels?.giftError || 'The free gift could not be confirmed. Please try again.');
    return data;
  }
  async function trimAddons(cart) {
    const addons = cart.items.filter(item => addonHandles.has(item.handle));
    if (!addons.length) return false;
    const hasMainItem = cart.items.some(item => !addonHandles.has(item.handle) && Number(item.final_line_price) > 0);
    const seen = new Set();
    let changed = false;
    for (const line of addons) {
      const quantity = hasMainItem && !seen.has(line.handle) ? 1 : 0;
      seen.add(line.handle);
      if (Number(line.quantity) !== quantity) { await request('cart/change.js', { id: line.key, quantity }); changed = true; }
    }
    return changed;
  }
  async function reconcile() {
    let before = await request('cart.js');
    const trimmed = await trimAddons(before);
    if (trimmed) before = await request('cart.js');
    const count = before.items.reduce((sum, item) => sum + (eligibleIds.has(Number(item.variant_id)) && !item.selling_plan_allocation ? Number(item.quantity) : 0), 0);
    const gifts = before.items.filter(item => Number(item.variant_id) === giftId);
    let changed = trimmed;
    if (count >= 2) {
      if (!gifts.length) {
        await request('cart/add.js', { items: [{ id: giftId, quantity: 1, properties: { '_PuzzlePup gift': 'Classic Smart Snuffle Mat with two supplement jars' } }] });
        changed = true;
      } else {
        if (gifts[0].quantity !== 1) { await request('cart/change.js', { id: gifts[0].key, quantity: 1 }); changed = true; }
        for (const line of gifts.slice(1)) { await request('cart/change.js', { id: line.key, quantity: 0 }); changed = true; }
      }
    } else {
      for (const line of gifts) { await request('cart/change.js', { id: line.key, quantity: 0 }); changed = true; }
    }
    const after = changed ? await request('cart.js') : before;
    const eligibleQuantity = after.items.reduce((sum, item) => sum + (eligibleIds.has(Number(item.variant_id)) && !item.selling_plan_allocation ? Number(item.quantity) : 0), 0);
    const confirmedGifts = after.items.filter(item => Number(item.variant_id) === giftId);
    const actual = confirmedGifts.reduce((sum, item) => sum + Number(item.quantity), 0);
    if (actual !== (eligibleQuantity >= 2 ? 1 : 0)) throw new Error(window.PuzzlePupCroLabels?.giftError || 'Please retry the free gift check.');
    if (eligibleQuantity >= 2 && confirmedGifts.some(item => item.selling_plan_allocation || Number(item.final_line_price) !== 0 || Number(item.final_price) !== 0)) {
      throw new Error('The Classic Snuffle Mat was not confirmed as free. Please retry before checking out.');
    }
    return { changed, eligibleQuantity, giftQuantity: actual, cart: after };
  }
  function sync(options = {}) {
    if (activeSync) { rerun = true; return activeSync; }
    activeSync = (async () => {
      let result, changed = false;
      do { rerun = false; result = await reconcile(); changed = changed || result.changed; } while (rerun);
      if (changed && options.refresh !== false) await window.PuzzlePupStorefront?.refreshCartSurfaces?.();
      return { ...result, changed };
    })().finally(() => { activeSync = null; });
    return activeSync;
  }
  function showError(error) {
    document.querySelectorAll('[data-pp-gift-feedback]').forEach(node => { node.hidden = false; node.textContent = error.message; });
  }
  const schedule = () => { sync().catch(showError); };
  async function beforeCheckout(event, trigger, form) {
    event.preventDefault(); event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    const original = trigger?.textContent;
    if (trigger?.tagName === 'BUTTON') { trigger.disabled = true; trigger.textContent = window.PuzzlePupCroLabels?.adding || 'Checking your cart…'; }
    try {
      await sync({ refresh: false });
      if (form) {
        allowedForms.add(form);
        if (trigger?.tagName === 'BUTTON') trigger.disabled = false;
        form.requestSubmit(trigger?.form === form ? trigger : undefined);
      } else window.location.assign(route('checkout'));
    } catch (error) {
      showError(error);
      if (trigger) trigger.insertAdjacentText('afterend', ' ' + error.message);
    } finally {
      checkoutBusy = false;
      if (trigger?.tagName === 'BUTTON') { trigger.disabled = false; trigger.textContent = original; }
    }
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('button[name="checkout"],input[name="checkout"],a[href="/checkout"]');
    if (trigger) beforeCheckout(event, trigger, trigger.form);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (allowedForms.has(form)) { allowedForms.delete(form); return; }
    if (event.submitter?.name === 'checkout') beforeCheckout(event, event.submitter, form);
  }, true);
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  document.addEventListener('pp:cart-updated', schedule);
  document.addEventListener('cart:updated', schedule);
  // Shrine replaces its cart contents without emitting a DOM cart event.
  // Watch those replacements so gift eligibility also follows native quantity edits.
  if (typeof MutationObserver !== 'undefined') {
    let cartRefreshTimer;
    new MutationObserver(mutations => {
      const cartChanged = mutations.some(mutation => {
        const target = mutation.target;
        return mutation.type === 'childList' && target instanceof Element &&
          (target.matches('cart-drawer-items,cart-items,#CartDrawer-CartItems,#main-cart-items') ||
           target.closest('cart-drawer-items,cart-items,#main-cart-items') ||
           [...mutation.addedNodes].some(node => node instanceof Element &&
             (node.matches('cart-drawer-items,cart-items') || node.querySelector('cart-drawer-items,cart-items'))));
      });
      if (cartChanged) {
        clearTimeout(cartRefreshTimer);
        cartRefreshTimer = setTimeout(schedule, 120);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  window.addEventListener('pageshow', schedule);
  window.PuzzlePupSeptemberGift = Object.freeze({ sync });
})();
